module.exports = __webpack_public_path__ + "img/uploader-drop.8398c673.svg";